var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_7217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15.0161C23 16.4668 22.6427 17.8054 21.928 19.0321C21.2133 20.2588 20.2427 21.2294 19.016 21.9441C17.7893 22.6588 16.4507 23.0161 15 23.0161C13.5493 23.0161 12.2107 22.6588 10.984 21.9441C9.75733 21.2294 8.78667 20.2588 8.072 19.0321C7.35733 17.8054 7 16.4668 7 15.0161C7 13.5654 7.35733 12.2268 8.072 11.0001C8.78667 9.77345 9.75733 8.80278 10.984 8.08811C12.2107 7.37345 13.5493 7.01611 15 7.01611C16.4507 7.01611 17.7893 7.37345 19.016 8.08811C20.2427 8.80278 21.2133 9.77345 21.928 11.0001C22.6427 12.2268 23 13.5654 23 15.0161ZM21.128 15.0161C21.128 13.3308 20.528 11.8881 19.328 10.6881C18.128 9.48811 16.6853 8.88811 15 8.88811C13.656 8.88811 12.4507 9.28278 11.384 10.0721L19.944 18.6321C20.7333 17.5654 21.128 16.3601 21.128 15.0161ZM18.616 19.9601L10.056 11.4001C9.26667 12.4668 8.872 13.6721 8.872 15.0161C8.872 16.7014 9.472 18.1441 10.672 19.3441C11.872 20.5441 13.3147 21.1441 15 21.1441C16.344 21.1441 17.5493 20.7494 18.616 19.9601Z",
    fill: "#F1416C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_7217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.f318408a9156afbead91cef4097e87b1.svg";
export { ForwardRef as ReactComponent };